// extracted by mini-css-extract-plugin
export default {"radio":"Radio_radio__OpT9j","label":"Radio_label__kOcLc"};